// Vehicle-identity utilities — one home for the two cross-cutting rules:
//   - normalizeSeriesId: the canonical seriesId SPELLING (input safety).
//   - buildVehicleSlug / parseVehicleSlug: the DP page slug format.
//
// Renames (priusprime → priuspluginhybrid) are NOT handled here — the VP router's
// year dropdown derives those from nav `previousSeriesIds` (getNewestModel /
// fetchModelYears). There is intentionally no resolver in this module.

// Canonical seriesId SPELLING — lowercase + strip `[\s\-_]`. It folds the casing/
// separators of an id that is ALREADY a seriesId (`GR-COROLLA` / `gr corolla` →
// `grcorolla`) so USER-CONTROLLED input — bookmarks, hand-typed or linked URLs —
// matches the canonical DB/VAPI key. It is not a lookup and nothing is
// maintained; it only normalizes spelling for input safety.
export function normalizeSeriesId(raw) {
  return String(raw ?? "")
    .toLowerCase()
    .trim()
    .replace(/[\s\-_]/g, "");
}

// The DP page slug is `{seriesId}-{year}`; the model year is ALWAYS a trailing
// 4-digit suffix, so the model capture is greedy. One rule, used everywhere.
const VEHICLE_SLUG_RE = /^(.+)-(\d{4})$/;

/**
 * Build the canonical `{seriesId}-{year}` DP slug. The model is canonicalized
 * (separator-free, lowercase) so the slug always matches the seeded form.
 */
export function buildVehicleSlug(model, year) {
  return `${normalizeSeriesId(model)}-${year}`;
}

/**
 * Parse a `{model}-{year}` slug into `{ model, year }`, or null. Robust to
 * hyphenated model names (`gr-corolla-2026` → `gr-corolla`); models without a
 * trailing `-\d{4}` (e.g. a bare `gr86`) return null.
 */
export function parseVehicleSlug(slug) {
  if (typeof slug !== "string") return null;
  const m = slug.trim().toLowerCase().match(VEHICLE_SLUG_RE);
  return m ? { model: m[1], year: Number(m[2]) } : null;
}
